import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectAccessToken } from '../../../slices/staffSlice';
import { authStaff } from "../../../utils/constants";
import { fetchRequests } from "../../../Requests/getRequests";
import { show } from '../../../slices/toastSlice';
import { Loader } from "../../../components";

function Deactivate({ _id, approved }) {

    const navigate = useNavigate();
    const accessToken = useSelector(selectAccessToken);
    const dispatch = useDispatch();
    const [confirmed, setConfirmed] = useState(false);
    const [process, setProcess] = useState(false);

    const handleAction = async () => {
        if (!confirmed) {
            setConfirmed(true);
            return;
        }

        setProcess(true);
        const res = await fetchRequests(`/auth/staff/disable`, "PUT", authStaff(accessToken), {}, {
            _id,
            status: !approved,
        });
        setProcess(false);

        if (res?.code === 401) {
            sessionStorage.clear();
            navigate("/login");
            dispatch(show({ type: "error", state: true, message: "Your session has expired. Please login to continue." }));
            return;
        }

        dispatch(show({ type: "success", state: true, message: res?.message }));
        setTimeout(() => navigate('/admin/staff'), 1500);
    };

    if (confirmed) {
        return (
            <div className="rounded-lg border border-red-100 bg-red-50 p-4">
                <p className="text-sm font-semibold text-red-700 mb-1">Are you sure?</p>
                <p className="text-xs text-red-600 leading-relaxed">
                    This will {approved ? 'deactivate' : 'activate'} this staff account.
                </p>
                <div className="flex items-center gap-2.5 mt-3">
                    <button
                        type="button"
                        onClick={handleAction}
                        disabled={process}
                        className={`inline-flex items-center gap-2 px-3.5 py-2 text-xs font-medium text-white rounded-lg disabled:opacity-50 transition-colors ${approved ? 'bg-red-600 hover:bg-red-700' : 'bg-emerald-600 hover:bg-emerald-700'}`}
                    >
                        {process && <Loader color="text-white" size="w-3.5 h-3.5" />}
                        Yes, {approved ? 'deactivate' : 'activate'} account
                    </button>
                    <button
                        type="button"
                        onClick={() => setConfirmed(false)}
                        className="px-3.5 py-2 text-xs font-medium text-gray-600 hover:text-gray-800 transition-colors"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        );
    }

    return (
        <button
            type="button"
            onClick={handleAction}
            className={`inline-flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg transition-colors ${
                approved
                    ? 'text-red-600 bg-red-50 border border-red-100 hover:bg-red-100'
                    : 'text-emerald-600 bg-emerald-50 border border-emerald-100 hover:bg-emerald-100'
            }`}
        >
            {approved ? 'Deactivate Account' : 'Activate Account'}
        </button>
    );
}

export default Deactivate;
